import { Link } from 'react-router-dom';
import { primaryNav, secondaryNav, siteInfo } from '@/mocks/gossip';
import NewsletterForm from '@/components/feature/NewsletterForm';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-20 bg-primary-950 text-background-100">
      <div className="mx-auto max-w-[1240px] px-4 py-14 md:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-4">
            <h2 className="flex items-center gap-2 font-heading text-2xl font-black tracking-[0.14em] text-background-50">
              <span className="flex h-2 w-2 items-center justify-center rounded-full bg-accent-400" aria-hidden="true" />
              诱惑吃瓜
            </h2>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-200/80">
              {siteInfo.description}
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href={`mailto:${siteInfo.email}`}
                rel="nofollow"
                className="flex items-center gap-2 rounded-md border border-primary-700 bg-primary-900/50 px-3 py-2 text-xs text-background-100 transition-colors hover:border-accent-400 hover:text-accent-300"
              >
                <i className="ri-mail-line text-base" aria-hidden="true"></i>
                {siteInfo.email}
              </a>
            </div>
          </div>

          <div className="md:col-span-2">
            <h2 className="text-xs font-semibold tracking-[0.2em] text-accent-300">图集栏目</h2>
            <ul className="mt-4 space-y-2.5">
              {primaryNav.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-sm text-background-200/80 transition-colors hover:text-background-50"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h2 className="text-xs font-semibold tracking-[0.2em] text-accent-300">关于本站</h2>
            <ul className="mt-4 space-y-2.5">
              {secondaryNav.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-sm text-background-200/80 transition-colors hover:text-background-50"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h2 className="text-xs font-semibold tracking-[0.2em] text-accent-300">每周精选订阅</h2>
            <p className="mt-4 text-sm leading-relaxed text-background-200/80">
              留下邮箱，每周收到一期红毯名场面与同框高光合集，不打扰，不滥用。
            </p>
            <div className="mt-4">
              <NewsletterForm />
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-primary-800 pt-6 text-xs text-background-200/70 sm:flex-row">
          <p>© {year} 诱惑吃瓜 · 专注颜值与视觉盛宴</p>
          <p className="flex items-center gap-2">
            <i className="ri-shield-check-line text-base text-accent-300" aria-hidden="true"></i>
            内容仅作视觉欣赏与造型解读
          </p>
        </div>
      </div>
    </footer>
  );
}